module.exports = __webpack_public_path__ + "static/media/BTIT.466308c4.svg";